module.exports = __webpack_public_path__ + "static/media/delantal (6).f0fbfd6f.jpg";